// main.tsx
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { AuthProvider } from "./contexts/AuthContext.tsx";
import { JourneyProvider } from "./contexts/JourneyContext";
import { LoaderProvider } from "./contexts/LoaderContext";
import React from "react";
// import axios from "axios";
import axios from "./lib/axios";


// ✅ Enable sending cookies (session/csrf)
axios.defaults.withCredentials = true;

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>     {/* 🔒 Single shared context for all pages */}
      <LoaderProvider>
        <JourneyProvider>
          <App />
        </JourneyProvider>
      </LoaderProvider>
    </AuthProvider>
  </React.StrictMode>
);
